// extracted by mini-css-extract-plugin
export default {"content":"legal_content__h3kuM","title":"legal_title__GSx-e","text":"legal_text__WU6Az","privacy_policy":"legal_privacy_policy__H4HMz"};